export { PageHeader } from './PageHeader';
export type { PageHeaderProps } from './PageHeader';